<label id="referrer-radio">Hoe bent u bij Fixteam Drenthe terecht gekomen?*</label>
<mat-radio-group aria-labelledby="referrer-radio" [formControl]="control">
  @for (option of options; track $index) {
    <mat-radio-button [value]="option">{{ option }}</mat-radio-button>
  }
</mat-radio-group>
